import React, { useEffect } from 'react';

export function PrivacyPolicy () {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://app.termly.io/embed-policy.min.js';
    script.async = true;
    document.body.appendChild(script);
  }, []);

  return (
    
    <div
      name="termly-embed"
      data-id="69a83665-5d8c-4405-bd0f-d3e3ee39a6fc"
      data-type="iframe"
    />
  );
}
